import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { loaderActions } from "../../../../_actions/loader.actions";
import { getData, postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import { CommonFileURLWithFolder } from "../../../../ImageUpload/ImageCommon";
import { HotelResponseTime } from "../../../../components/commonClass/CommonValidation";
import { decryptUrlDatapattern, encryptUrlDatapattern } from "../../../../components/commonClass/EncFunc";
import HotelGalleryViewModel from "./HotelGalleryViewModel";
import Lightbox from 'yet-another-react-lightbox'
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import { ClearLocalStorage, GetLocalStorage } from "../../../../components/commonClass/Session";
import Accordion from "../../../../components/Accordion";
import OverViewIcon from '../../../../assets/img/hotel/holiday-icon3.svg'
import AmenitiesIcon from '../../../../assets/img/hotel/icon-holiday-itinerary.svg'
import propertyAndRulesIcon from '../../../../assets/img/hotel/icon-holiday-property-rools.svg'
import roomIcon from '../../../../assets/img/hotel/icon-holiday-room.svg'
import locationIcon from '../../../../assets/img/hotel/icon-holiday-location.svg'
import OverviewExpand from "./OverviewExpand";
import { numberWithCommas } from "../../BookingConfirmScreen/Hotels/HotelBookingConfirmation";

const HotelsDetails = () => {
    const [payloadObj, setPayloadObj] = useState<any>({});
    const [searchParams, setSearchParams] = useSearchParams();
    const [hotelDetails, setHotelDetails] = useState<any>([]);
    const [showMoreAmenities, setShowMoreAmenities] = useState(0);
    const [selectedRoom, setSelectedRoom] = useState<any>({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const [personCount, setPersonCount] = useState<any>({});
    const [pexroomobj, setPexRoomObj] = useState<any>([])
    const [bannerDetails, setBannerDetails] = useState({});
    const APIBadMessage = 'Something went wrong, Please try again!';

    //image view
    const [galleryviewModal, setGalleryViewModal] = useState(false);
    const [isOpenImage, setIsOpenImage] = useState(false);
    const [indexImage, setIndexImage] = useState(1);
    const [srcImage, setSrcImage] = useState<any>([]);
    const [galleryViewData, setGalleryViewData] = useState([]);

    const PreviewImageOnClick = (imageList: any, imageIndex: any) => {
        setSrcImage([]);
        imageList?.map((value: any) => {
            setSrcImage((current: any) => [...current, { ...srcImage, src: value }])
        })
        setIsOpenImage(true);
        setIndexImage(imageIndex)
    }

    const openGalleryPopupDataViewAll = (imageList: any) => {
        setGalleryViewModal(true);
        setGalleryViewData(imageList);
    }

    const getHotelDetails = async (obj: any) => {
        dispatch(loaderActions.start());
        const hotelDetails = await postUsersData('/customerui/v1/gethoteldetails', obj);

        const roomImages = hotelDetails?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.roomImages;

        hotelDetails?.data?.hotelResult?.[0]?.rooms?.map((room: any) => {
            room.images = roomImages?.find((roomImg: any) => room?.tboRoomID === roomImg?.roomId)?.images || [];
            return room;
        })

        if (hotelDetails.status) {
            setHotelDetails(hotelDetails?.data?.hotelResult?.[0])
            setSelectedRoom({ ...hotelDetails?.data?.hotelResult?.[0]?.rooms?.[0], indexId: 0 })
            setShowMoreAmenities(
                hotelDetails?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.hotelFacilities?.length > 22 ? 22
                    : hotelDetails?.data?.hotelResult?.[0]?.hotelDetails?.[0]?.hotelFacilities?.length
            )
            dispatch(loaderActions.end());
        } else {
            dispatch({ type: 'ALERTING', message: hotelDetails?.message || APIBadMessage, redirectTo: '/' });
            dispatch(loaderActions.end());
        }
    }

    // Fetch filter data
    const getFilterData = async () => {
        dispatch(loaderActions.start());
        const rep = await getData('/customerui/v1/gethoteluiconfigurations');

        if (rep?.status) {
            setBannerDetails((previous) => ({
                ...previous,
                bannerdetails: rep?.data?.bannerdetails,
                bannerImageURL: `${CommonFileURLWithFolder}${rep?.data?.bannerdetails?.[0]?.ImagePath}`
            }));
            // dispatch(loaderActions.end());
        }
    };

    const fetchData = async (payLoad: any) => {
        await getHotelDetails(payLoad);
    };

    useEffect(() => {
        let obj = Object.fromEntries(searchParams.entries());

        if (!obj?.HotelCodes) {
            navigate('/hotel')
        }

        const transformObject = (obj: any) => {
            const paxRooms: any = [];

            let roomId = 1;
            while (obj[`roomReq${roomId}noOfAdult`] !== undefined) {
                const adultsKey = `roomReq${roomId}noOfAdult`;
                const childrenKey = `roomReq${roomId}noOfChildren`;
                const childrenAgesKey = `roomReq${roomId}childrenAge`;

                let adults = obj[adultsKey] ? Number(obj[adultsKey]) : 0;
                let children = obj[childrenKey] ? Number(obj[childrenKey]) : 0;
                let childrenAges = [];

                if (children > 0) {
                    for (let j = 1; j <= children; j++) {
                        const childAge = obj[`${childrenAgesKey}${j}`];
                        if (childAge) {
                            childrenAges.push(Number(childAge));
                        }
                    }
                }

                paxRooms.push({
                    "Adults": adults,
                    "Children": children,
                    "ChildrenAges": childrenAges.length > 0 ? childrenAges : null
                });

                roomId++;
            }
            setPexRoomObj(paxRooms)
            let adultTotal = paxRooms.reduce((acc: any, val: any) => {
                acc.Adults += +val?.Adults || 0;
                acc.Children += +val?.Children || 0;
                return acc;
            }, { Adults: 0, Children: 0 });


            setPersonCount(adultTotal)

            const payloadObjs = {
                "CheckIn": obj.CheckIn,
                "CheckOut": obj.CheckOut,
                "HotelCodes": obj.HotelCodes,
                "GuestNationality": obj.GuestNationality,
                "PaxRooms": paxRooms,
                "ResponseTime": HotelResponseTime,
                "IsDetailedResponse": true,
                "Filters": {
                    "Refundable": false,
                    "NoOfRooms": 0,
                    "MealType": 0,
                    "OrderBy": 0,
                    "StarRating": 0,
                    "HotelName": null
                },
                "CityCode": obj.CityCode ? Number(obj.CityCode) : 0,
                "UserRating": obj?.UserRating ? decryptUrlDatapattern(obj?.UserRating) : [],
                "Amenities": obj?.Amenities ? obj?.Amenities?.split(',') : [],
                "Price": Number(obj?.Price) ? Number(obj?.Price) : 100000
            };
            setPayloadObj(payloadObjs)
            return payloadObjs
        };

        fetchData(transformObject(obj));
        getFilterData();

    }, [])

    const getNight: any = useMemo(() => {
        const inDate: any = searchParams.get('CheckIn') ? searchParams.get('CheckIn') : null
        const outDate: any = searchParams.get('CheckOut') ? searchParams.get('CheckOut') : null
        const checkIn: any = new Date(inDate);
        const checkOut: any = new Date(outDate);

        const millisecondsPerDay = 1000 * 60 * 60 * 24;
        const nights = (checkOut - checkIn) / millisecondsPerDay;

        return nights
    }, [searchParams.get('CheckIn'), searchParams.get('CheckOut')])


    // Split it into latitude and longitude
    const coodinate = hotelDetails?.hotelDetails?.[0]?.map?.split('|');
    const dynamicGoogleMapUrl = `https://www.google.com/maps?q=${coodinate?.[0]},${coodinate?.[1]}&hl=es;z=14&output=embed`;

    const handleTabChange = (e: any) => {
        e.preventDefault();
        const target = document?.querySelector(e?.target?.getAttribute('href'));
        const targetContentPosition = target?.offsetTop;
        window.scrollTo({
            top: targetContentPosition - 50,
            behavior: 'smooth'
        });
    }

    const insertorupdatehoteltravellerbooking = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {

            pexroomobj?.map((obj: any, index: any) => {
                selectedRoom?.name?.map((room: any, roomIndex: any) => {
                    if (index === roomIndex) {
                        obj.RoomType = room;
                    }
                })
                return obj;
            })

            dispatch(loaderActions.start());
            const user: any = GetLocalStorage();
            const form = {
                "BookingCode": selectedRoom?.bookingCode || "",
                "HotelBookingId": 0,
                "CheckInDate": searchParams.get('CheckIn') || null,
                "CheckoutDate": searchParams.get('CheckOut') || null,
                "BookingId": null,
                "InvoiceNumber": null,
                "ConfirmationNo": null,
                "BookingRefNo": null,
                "IsPriceChanged": false,
                "IsCancellationPolicyChanged": false,
                "Adults": personCount?.Adults || 0,
                "Children": personCount?.Children || 0,
                "BaseFare": selectedRoom?.baseprice || 0,
                "TotalFare": selectedRoom?.totalFare || 0,
                "TotalTax": selectedRoom?.totalTax || 0,
                "NetAmount": 0,
                "NetTax": 0,
                "PriceWithMarkup": selectedRoom?.priceWithMarkup || 0,
                "MarkupCharges": selectedRoom?.markupCharges || 0,
                "GstCharges": selectedRoom?.gstCharges || 0,
                "FinalValue": selectedRoom?.grandTotal || 0,
                "Status": 0,
                "UserId": user?.userMasterID || 0,
                "NoOfRooms": pexroomobj?.length || 0,
                "HotelCode": hotelDetails?.hotelCode || "",
                "HotelName": hotelDetails?.hotelDetails?.[0]?.hotelName || "",
                "HotelRating": hotelDetails?.hotelDetails?.[0]?.hotelRating || 0,
                "HotelAddress": hotelDetails?.hotelDetails?.[0]?.address || "",
                "PaxRooms": pexroomobj,
            }

            const getdata = await postUsersData("/customerui/v1/insertorupdatehoteltravellerbooking", form);
            if (getdata?.status) {
                const urlParams = new URLSearchParams();
                urlParams.set('code', encryptUrlDatapattern(selectedRoom?.bookingCode));
                navigate(`/hotel/review?${urlParams?.toString()}`, { state: { ...payloadObj, BookingId: encryptUrlDatapattern(getdata.data) } });
                dispatch(loaderActions.end());
            }
            else {
                dispatch({ type: 'ALERTING', message: getdata?.message || APIBadMessage, redirectTo: '/' });
                dispatch(loaderActions.end());
            }
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }


    const hendleContinue = () => {
        const userData = GetLocalStorage();
        if (userData) {
            insertorupdatehoteltravellerbooking()
        }
        else {
            dispatch({ type: "SHOW_OR_HIDE_LOGIN_MODEL", payload: true });
        }
    }

    return (
        <>
            <div className="navOverlay"></div>
            <section className="midSection pt-1">
                <div className="grid-wrapper container mb-3 pt-2">
                    <div className="wide">
                        <img
                            src={hotelDetails?.hotelDetails?.[0]?.images?.[0] || ""}
                            loading='lazy'
                            onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                            alt=""
                            onClick={(e) => PreviewImageOnClick(hotelDetails?.hotelDetails?.[0]?.images, 0)}
                        />
                    </div>
                    <div className="">
                        <img
                            src={hotelDetails?.hotelDetails?.[0]?.images?.[1] || ""}
                            onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                            alt=""
                            loading='lazy'
                            onClick={(e) => PreviewImageOnClick(hotelDetails?.hotelDetails?.[0]?.images, 1)}
                        />
                    </div>
                    <div className="">
                        <img
                            src={hotelDetails?.hotelDetails?.[0]?.images?.[2] || ""}
                            onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                            alt=""
                            loading='lazy'
                            onClick={(e) => PreviewImageOnClick(hotelDetails?.hotelDetails?.[0]?.images, 2)}
                        />
                    </div>
                    <div className="">
                        <img
                            src={hotelDetails?.hotelDetails?.[0]?.images?.[3] || ""}
                            onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                            alt=""
                            loading='lazy'
                            onClick={(e) => PreviewImageOnClick(hotelDetails?.hotelDetails?.[0]?.images, 3)}
                        />
                    </div>
                    <div className="view-all">
                        <img
                            src={hotelDetails?.hotelDetails?.[0]?.images?.[4] || ""}
                            onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                            alt=""
                            loading='lazy'
                            onClick={(e) => openGalleryPopupDataViewAll(hotelDetails?.hotelDetails?.[0]?.images)}
                        />
                        <button type="button" className="centered cursor_pointer border-0 h-auto" onClick={(e) => openGalleryPopupDataViewAll(hotelDetails?.hotelDetails?.[0]?.images)}>View All</button>
                    </div>
                </div>
                <div className="container mb-5">
                    <div className="Package-title">
                        <h3>{hotelDetails?.hotelDetails?.[0]?.hotelName}</h3>
                    </div>

                    <div className="row">
                        <div className="holidaydetailContainer">
                            <div className="holiday-detail-head-tab">
                                <ul className="tab-links">
                                    <li><a href="#overview" onClick={(e) => handleTabChange(e)}>Overview</a></li>
                                    <li><a href="#amenities" onClick={(e) => handleTabChange(e)}>Amenities</a></li>
                                    <li><a href="#propertyRules" onClick={(e) => handleTabChange(e)}>Property Rules</a></li>
                                    <li><a href="#rooms" onClick={(e) => handleTabChange(e)}>Rooms</a></li>
                                    <li><a href="#location" onClick={(e) => handleTabChange(e)}>Location</a></li>
                                </ul>
                            </div>

                            {/* <!-- overview Section --> */}
                            <div id="overview" className="holiday-details-sec">
                                <Accordion
                                    title="Overview"
                                    icon={OverViewIcon}
                                >
                                    <OverviewExpand
                                        html={hotelDetails?.hotelDetails?.[0]?.description}
                                        limit={2500}
                                    />
                                </Accordion>
                            </div>

                            {/* <!-- itinerary Section --> */}
                            <div id="amenities" className="holiday-details-sec">
                                <Accordion
                                    title="Amenities"
                                    icon={AmenitiesIcon}
                                >
                                    <div className="detailDiv room-detail-list content amenitiesSec">
                                        <ul className='row pt-0'>
                                            {hotelDetails?.hotelDetails?.[0]?.hotelFacilities?.slice(0, showMoreAmenities)?.map((amenity: any) => (
                                                <li className='col-md-4 col-6 text-wrap'>{amenity}</li>
                                            ))}

                                            {showMoreAmenities < hotelDetails?.hotelDetails?.[0]?.hotelFacilities?.length
                                                ? <span onClick={() => setShowMoreAmenities(hotelDetails?.hotelDetails?.[0]?.hotelFacilities.length)} className='col-md-4 col-6 text-primary cursor_pointer' >
                                                    View More
                                                </span>
                                                : <span onClick={() => setShowMoreAmenities(22)} className='col-md-4 col-6 text-primary cursor_pointer' >View Less</span>}
                                        </ul>

                                    </div>
                                </Accordion>
                            </div>

                            {/* <!-- inclusions Section --> */}
                            <div id="propertyRules" className="holiday-details-sec">
                                <Accordion
                                    title="Property Rules"
                                    icon={propertyAndRulesIcon}
                                    isOpen={true}
                                >
                                    <p><i className="fa-regular fa-clock"></i> Check-in: After {hotelDetails?.hotelDetails?.[0]?.checkInTime}, Check-out: {hotelDetails?.hotelDetails?.[0]?.checkOutTime}</p>
                                    <p><i className="fa-regular fa-calendar-check"></i> Cancellation till check-in available, with ClearChoice Max</p>
                                </Accordion>
                            </div>

                            {/* <!-- exclusions Section --> */}
                            <div id="rooms" className="holiday-details-sec">
                                <Accordion
                                    title="Rooms"
                                    icon={roomIcon}
                                    isOpen={true}
                                >
                                    <div className="roomlist">
                                        <div className="col-lg-12">
                                            <h3>{hotelDetails?.rooms?.[0]?.name?.[0]?.split(',')?.[0]}</h3>
                                        </div>

                                        {/* <div className="col-lg-4 col-md-4 col-sm-3"> */}


                                        {/* <div className={`col-lg-8 col-md-8 col-sm-9`}> */}
                                        {hotelDetails?.rooms?.length > 0 && hotelDetails?.rooms?.map((room: any, index: any) => (
                                            <div className='row mb-3'>
                                                <div className="col-lg-4 col-md-12 col-sm-3">

                                                    <div className="room-gallery">
                                                        <div className="lg-image">
                                                            <img
                                                                src={room?.images?.[0] || ""}
                                                                alt="Main Room"
                                                                onClick={(e) => room?.images?.[0] && PreviewImageOnClick(room?.images, 0)}
                                                                onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                                                            />
                                                        </div>

                                                        <div className="thumbs">
                                                            <div className="thumb">
                                                                <img
                                                                    src={room?.images?.[1] || ""}
                                                                    alt=""
                                                                    onClick={(e) => room?.images?.[1] && PreviewImageOnClick(room?.images, 1)}
                                                                    onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                                                                />
                                                            </div>
                                                            <div className="thumb">
                                                                <img
                                                                    src={room?.images?.[2] || ""}
                                                                    alt=""
                                                                    onClick={(e) => room?.images?.[2] && PreviewImageOnClick(room?.images, 2)}
                                                                    onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                                                                />
                                                            </div>
                                                            <div className="thumb view-all">
                                                                <img
                                                                    src={room?.images?.[3] || ""}
                                                                    alt=""
                                                                    onClick={(e) => room?.images?.length > 0 && openGalleryPopupDataViewAll(room?.images)}
                                                                    onError={(e: any) => e.target.src = require("../../../../assets/img/no-image.png")}
                                                                />
                                                                <span
                                                                    onClick={(e) => room?.images?.length > 0 && openGalleryPopupDataViewAll(room?.images)}
                                                                >View All</span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className={`col-lg-8 col-md-12 col-sm-9`}>
                                                    <div className="roomsDetail">
                                                        <div className="detail">
                                                            <h4>{room.name?.[0]} {room?.mealType ? `- ${room?.mealType?.replace("_", " ")}` : ""} </h4>
                                                            {
                                                                room?.roomPromotion &&
                                                                <div className="col-12 my-3">
                                                                    <div className='text-muted fw-500' style={{ fontSize: '14px', wordBreak: 'break-word' }}>Room Promotion {room?.roomPromotion?.[0]} </div>
                                                                </div>
                                                            }
                                                            <div className="row g-2">
                                                                <div className="col-md-6 col-12 inclusions">
                                                                    <h5>Inclusions</h5>
                                                                    <ul>
                                                                        {room?.inclusion?.split(',').map((inc: any, index: any) => (<li key={index}>{inc}</li>))}
                                                                    </ul>
                                                                </div>
                                                                <div className="col-md-6 col-12 highlights">
                                                                    <h5>Highlights</h5>
                                                                    <ul>
                                                                        <li>{room?.isRefundable ? 'Refundable' : 'Non-Refundable'}</li>
                                                                    </ul>
                                                                </div>
                                                                {
                                                                    room?.supplements?.[0]?.length > 0 &&
                                                                    <div className="col-md-6 col-12 inclusions">
                                                                        <h5>Supplements</h5>
                                                                        <ul>
                                                                            {
                                                                                room?.supplements?.[0]?.map((supp: any, suppIndex: any) =>
                                                                                    (<li key={`supp${suppIndex}`} > {supp?.type} {supp?.price} {supp?.currency} ({supp?.description}) </li>)
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                }
                                                                {
                                                                    room?.cancelPolicies?.length > 0 &&
                                                                    <div className="accordion">
                                                                        <div className="accordion-item me-2">
                                                                            <h2 className="accordion-header">
                                                                                <button className="btn acc-button" style={{ fontSize: '16px', fontWeight: '500' }}
                                                                                    type="button"
                                                                                    data-bs-toggle="collapse"
                                                                                    data-bs-target={`#roomCancellationPolicy${index}`}
                                                                                    aria-expanded="true"
                                                                                    aria-controls={`roomCancellationPolicy${index}`}>
                                                                                    Cancellation Policy
                                                                                    <i className="ms-2 fa-solid fa-angle-down"></i>
                                                                                </button>
                                                                            </h2>
                                                                            <div id={`roomCancellationPolicy${index}`} className="accordion-collapse collapse show">
                                                                                <div className="accordion-body acc-body ">
                                                                                    <ul>
                                                                                        {
                                                                                            room?.cancelPolicies?.map((cp: any, cpIndex: any) => (
                                                                                                <li key={`cp${cpIndex}`} >
                                                                                                    From date: {cp?.fromDate} &nbsp;
                                                                                                    Cancellation charge: {cp?.chargeType?.toLowerCase() === "percentage" ? `${cp?.cancellationCharge} %` : `₹ ${cp?.cancellationCharge}`}
                                                                                                </li>
                                                                                            ))
                                                                                        }
                                                                                    </ul>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="priceBox">
                                                            <div className="price">
                                                                <h5><span>₹ {room?.priceWithMarkup}</span></h5>
                                                            </div>
                                                            <button onClick={() => setSelectedRoom({ ...room, indexId: index })} className={`btn booknow ${selectedRoom?.indexId === index ? "hotelactive" : ''}`} style={{ opacity: (selectedRoom?.indexId !== index) ? '0.6' : '1' }}>Select</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Accordion>
                            </div>

                            <div id="location" className="holiday-details-sec">
                                <Accordion
                                    title="Location"
                                    icon={locationIcon}
                                    isOpen={true}
                                >
                                    <iframe
                                        title='hotel-map'
                                        src={dynamicGoogleMapUrl}
                                        width="100%" height="450"
                                        loading="lazy"
                                    ></iframe>
                                </Accordion>
                            </div>
                        </div>

                        <div className="rightSec">
                            <div className="holidayPriceSummary">
                                <div className="priceSummary">
                                    <div className="title pr">
                                        <h5 className="mb-0">Price Summary</h5>
                                        <div className="person">
                                            {personCount?.Adults > 0 && (<span><i className="fa-solid fa-user"></i> {personCount.Adults} </span>)}
                                            {personCount?.Children > 0 && (<span><i className="fa-solid fa-children"></i> {personCount.Children} </span>)}
                                            {personCount?.Infant > 0 && (<span><i className="fa-solid fa-baby"></i> {personCount.Infant} </span>)}
                                        </div>
                                    </div>
                                    <div className="priceSummaryList">
                                        <ul>
                                            <li>
                                                <p>{payloadObj?.PaxRooms?.length} Room <span>x</span> {getNight} Night</p>
                                                <div className="price"><span>₹</span> {selectedRoom?.priceWithMarkup}</div>
                                            </li>
                                            {/* <li>
                                                <p>Total Discount <span>!</span> </p>
                                                <div className="price"><span>₹</span> 0</div>
                                            </li> */}
                                            {/* <li>
                                                <p>Price after Discount <span>!</span></p>
                                                <div className="price"><span>₹</span> 0</div>
                                            </li> */}
                                            <li>
                                                <p>Taxes and Surcharges <span>+</span> </p>
                                                <div className="price"><span>₹</span> {selectedRoom?.totalTax}</div>
                                            </li>
                                            <li className="total">
                                                <h4>Grand Total</h4>
                                                <div className="price">₹ {numberWithCommas(selectedRoom?.grandTotal)}
                                                    {/* {Math.round(selectedRoom.totalFare)} */}
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <button className="btn continueBtn" onClick={() => hendleContinue()}>Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {isOpenImage && (
                <>
                    <Lightbox
                        slides={srcImage}
                        open={indexImage >= 0}
                        index={indexImage}
                        close={() => { setIndexImage(-1); setSrcImage([]); }}
                        plugins={[Zoom]}
                        zoom={{
                            zoomInMultiplier: 2,
                            doubleTapDelay: 300,
                            doubleClickDelay: 300,
                            doubleClickMaxStops: 2,
                            keyboardMoveDistance: 50,
                            wheelZoomDistanceFactor: 100,
                            pinchZoomDistanceFactor: 100,
                            maxZoomPixelRatio: 5,
                        }}
                    />
                </>
            )}

            <HotelGalleryViewModel
                // travelRoomDetail={propertyDetailsData}
                galleryViewData={galleryViewData}
                galleryviewModal={galleryviewModal}
                setGalleryViewModal={setGalleryViewModal}
            ></HotelGalleryViewModel>
        </>
    )
}

export default HotelsDetails